import {
  SelectionTagGroup,
  SelectionTagGroupItem,
} from '@synoptic/ui-kit/selection-tag/selection-tag-group.tsx';
import { clsx } from 'clsx';
import { FC, useState } from 'react';
import {
  filterToggleGroup,
  filterToggleItem,
} from '@/components/filter-toggle-group/filter-toggle-group.css.ts';

export const FilterToggleGroup: FC<{
  filters: { title: string; value: string }[];
  selectedFilter: string;
  onReset: () => void;
  onSet: (category: string) => void;
  className?: string;
  itemClassName?: string;
}> = ({
  filters,
  selectedFilter,
  onReset,
  onSet,
  className,
  itemClassName,
}) => {
  const [currentValue, setCurrentValue] = useState<string>(selectedFilter);
  if (selectedFilter !== currentValue) {
    setCurrentValue(selectedFilter);
  }

  const onCategoryChange = async (value: string) => {
    // return if default value is selected
    if (!value && currentValue === filters[0].value) return;

    if (!value || value === filters[0].value) {
      setCurrentValue(filters[0].value);
      onReset();
    } else {
      setCurrentValue(value);
      onSet(value);
    }
  };

  return (
    <SelectionTagGroup
      type={'single'}
      value={currentValue}
      onValueChange={onCategoryChange}
      defaultValue={selectedFilter}
      className={clsx(filterToggleGroup, className)}
    >
      {filters.map((filter) => (
        <SelectionTagGroupItem
          key={filter.value}
          value={filter.value}
          aria-label={`Toggle ${filter.title}`}
          className={clsx(filterToggleItem, itemClassName)}
        >
          {filter.title}
        </SelectionTagGroupItem>
      ))}
    </SelectionTagGroup>
  );
};
